import Vue from "vue"
import Vuex from "vuex"
import {getBaseConfig, getPromotConfig} from '@/api/base'
import getters from './getters'

Vue.use(Vuex)

const modulesFiles = require.context('./modules', true, /\.js$/)
const modules = modulesFiles.keys().reduce((modules, modulePath) => {
  const moduleName = modulePath.replace(/^\.\/(.*)\.\w+$/, '$1')
  const value = modulesFiles(modulePath)
  modules[moduleName] = value.default
  return modules
}, {})
const state = {
  isCloseMenu: false, // 是否关闭左侧按钮
  isOpenSettingMenu: false, // 是否打开设置菜单
  keepAliveList: [
    {name: 'Welcome', path: '/workspace/welcome', title: '工作台', isNotAllowRemove: true}
  ], // 页面缓存列表
}
const mutations = {
  SETISOPENMENU (state) {
    state.isCloseMenu = !state.isCloseMenu;
  },
  SETSETTINGMENU (state, status) {
    state.isOpenSettingMenu = status;
  },
  SETKEEPALIVELIST (state, list) {
    state.keepAliveList = list;
  },
  RESETKEEPALIVELIST (state) {
    state.keepAliveList = [
      {name: 'Welcome', path: '/workspace/welcome', title: '工作台', isNotAllowRemove: true}
    ];
  }
}
const actions = {
  /** 获取配置列表 */
  initConfig ({}, keys) {
    return new Promise(async (resolve) => {
      try {
        const res = await getBaseConfig(keys.join(','));
        resolve(res);
      } catch (error) {
        resolve({});
      }
    })
  },
  // 获取投放系统配置
  initPromotConfig ({}, keys) {
    return new Promise(async (resolve) => {
      try {
        const res = await getPromotConfig(keys.join(','));
        resolve(res);
      } catch (error) {
        resolve({});
      }
    })
  }
}
export default new Vuex.Store({
  state,
  mutations,
  actions,
  modules,
  getters
});
